import React from 'react';
import { useTranslation } from 'react-i18next';
import { Search, Heart, Play } from 'lucide-react';

const Journey = () => {
  const { t } = useTranslation();

  const steps = [
    { number: 1, icon: Search, text: t('journey.steps.step1') },
    { number: 2, icon: Heart, text: t('journey.steps.step2') },
    { number: 3, icon: Play, text: t('journey.steps.step3') }
  ];

  return (
    <section className="py-20 md:py-32 relative overflow-hidden">
      {/* Background glow */}
      <div className="absolute top-1/2 left-0 w-[400px] h-[400px] bg-purple-500/10 rounded-full blur-[120px]" />
      <div className="absolute top-1/2 right-0 w-[400px] h-[400px] bg-red-500/10 rounded-full blur-[120px]" />

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="font-display text-3xl md:text-5xl font-bold mb-4">
            <span className="gaming-gradient-text">{t('journey.title')}</span>
          </h2>
          <p className="text-lg text-white/60 max-w-2xl mx-auto">
            {t('journey.subtitle')}
          </p>
        </div>

        {/* Steps title */}
        <h3 className="text-center text-xl font-semibold mb-12 text-white/80">
          {t('journey.steps.title')}
        </h3>

        {/* Steps */}
        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              {/* Connector line */}
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-6 left-1/2 w-full h-0.5 bg-gradient-to-r from-red-500/50 to-purple-500/50" />
              )}
              
              <div className="relative flex flex-col items-center text-center">
                <div className="step-number mb-6 relative z-10">
                  {step.number}
                </div>
                <div className="w-12 h-12 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center mb-4">
                  <step.icon className="w-6 h-6 text-red-400" />
                </div>
                <p className="text-white/70 font-medium">{step.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Journey;
